module.exports = __webpack_public_path__ + "img/feet-opaque.31af128f.svg";